import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

export const useClients = () => {
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchClients = useCallback(async () => {
        try {
            setLoading(true);
            setError('');
            const response = await axios.get('/api/comptable/clients');
            setClients(response.data || []);
        } catch (err) {
            setError('Erreur lors du chargement des clients.');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchClients();
    }, [fetchClients]);

    return {
        clients,
        loading,
        error,
        refetchClients: fetchClients,
    };
};
